module.exports = __webpack_public_path__ + "img/övp-logo.7c2f29a8.png";